export default __webpack_public_path__ + "static/media/free_gift.2011c30e.png";